import React, {useState, useEffect} from 'react';
import './index.sass';
import ButtonLink from "./ButtonLink";
import classNames from 'classnames';
import debounce from "lodash-es/debounce";


const LABELS = [
  { label: 'Возможности', anchor: 'offer' },
  { label: 'Компетенции', anchor: 'ability' },
  { label: 'Проекты',     anchor: 'projects' },
  { label: 'Технологии',  anchor: 'technologies' },
  { label: 'Контакты',    anchor: 'contacts' },
];

const Header = ({handleScroll, handleToggleMenu}) => {

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const onScroll = debounce(function () {
      setIsActive(window.pageYOffset > 10)
    }, 10);
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])


  return (
    <div className={classNames({
      'Header': true,
      'Header--Active': isActive
    })}>
      <div className="Header__Container container container--slim">
        <a className="Header__Logo" href="/" onClick={(e) => handleScroll('intro', e)}>
          <span className="Header__Logo-Mark">СП</span>
          <span className="Header__Logo-Text">Смарт&nbsp;СП</span>
        </a>

        <nav className='Header__Nav'>
          {
            LABELS.map(({label, anchor}) => (
                <ButtonLink
                    label={label}
                    anchor={anchor}
                    key={label}
                    handleScroll={handleScroll}
                />
            ))
          }
        </nav>

        <a href="mailto:info@smartsp.ru" className="Header__Cta">Обсудить проект</a>

        <div onClick={handleToggleMenu} className="Header__Toggler" aria-label="Меню">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Header;
